import React from "react";
import { Container, ContainerFW } from "../global";
import { WideCard } from "./WideCard";
export const TwoWideCards = ({ cardContent, backgroundColor }) => (React.createElement(ContainerFW, { backgroundColor: backgroundColor ? backgroundColor : "inherit" },
    React.createElement("div", { className: "two-wide-cards-root" },
        React.createElement(Container, null, cardContent.length && cardContent.map((card) => React.createElement(WideCard, { key: `unique${card.title}`, ...card, cardNumber: cardContent.length }))))));
